import { getAPI } from './api-service'

export const loadInsightsAPI = async ({
  groupName,
  surveyName = 'all',
  area
}) => {
  const path = `/insights/${surveyName}/${groupName}/${area}`
  return await getAPI('InsightsAPI', path)
}
